import {
  GET_RODO,
} from './actions'

const initState = {
  touched: false,
  nazwa: '',
  konto: '',
}
export const rodo = (state = initState, action) => {
    switch (action.type) {
      case GET_RODO:
        return { ...action.rodo, touched: true }
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/store/rodo/reducers.js